<app-autocomplete-select
  [multiple]="multiple"
  [options]="options"
  [searchFn]="search"
  [preloadFn]="preload"
  [placeholder]="placeholder"
  [selectClass]="selectClass"
  [pinnedLastOptionValues]="allowCreate ? pinnedCreateOptionValues : noPinnedOptionValues"
  [disabled]="disabled"
  [ngModel]="value"
  [ngModelOptions]="standaloneModelOptions"
  (ngModelChange)="valueChanged($event)"
></app-autocomplete-select>
<small class="text-danger d-block mt-1" *ngIf="lookupFailed">
  Business partners could not be loaded. Retry the search or create a new partner.
</small>
